import { render, staticRenderFns } from "./MeetingCollapse.vue?vue&type=template&id=96fbe1c8&"
import script from "./MeetingCollapse.vue?vue&type=script&lang=js&"
export * from "./MeetingCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports